import useAuthStore, {subscribeAuth} from "app/Service/Auth/AuthService"
import SuspenseLoader from "app/WebView/Component/Loader/SuspenseLoader"
import Logger from "logger/logger"
import React, {lazy, LazyExoticComponent, Suspense, useEffect, useState} from "react"

function ContentController() {

  const {isAuthenticated} = useAuthStore([
    subscribeAuth.isAuthenticated
  ], 'ContentController')

  const [Content, setContent] = useState<LazyExoticComponent<any>>()

  useEffect(() => {
    Logger('Controller.Content.init')
    return () => {
      Logger('Controller.Content.unloading')
    }
  }, [])

  useEffect(() => {
    if (undefined === isAuthenticated) return
    const path = isAuthenticated ? 'AuthenticatedContentController' : 'SiteController'
    setContent(lazy(() => import(`./${path}`)))
  }, [isAuthenticated])

  return (
    <Suspense fallback={<SuspenseLoader type={'app'}/>}>
      {Content && <Content/>}
    </Suspense>
  )
}

export default ContentController
